module.exports = __webpack_public_path__ + "static/wight-9575c371cf4d23835b8bf48c1d63a79c.jpeg";